import Filter from './filter';
import {FILTER_TYPE_TEXT} from 'src/js/lib/filtering/filters_definitions_constants';

class TextFilter extends Filter {
  constructor(filterData) {
    super(filterData);
    this.type = filterData.type || FILTER_TYPE_TEXT;
  }

  static fromString(serializedFilter) {
    const nameValueSepIdx = serializedFilter.indexOf(':');
    const property = serializedFilter.slice(0, nameValueSepIdx);
    // remove parenthesis

    if (serializedFilter.slice(nameValueSepIdx + 1) === '*') {
      return new TextFilter({property, value: null});
    }
    const value = serializedFilter.slice(nameValueSepIdx + 2, -1);
    return new TextFilter({property, value});
  }

  static fromSchema(schemaNode) {
    return new TextFilter({property: schemaNode.getName()});
  }

  clone() {
    return new TextFilter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      id: this.id,
    });
  }

  getValue() {
    return this.value;
  }

  isEqual(otherFilter) {
    return this.property === otherFilter.property;
  }

  toString() {
    if (this.value != null) {
      return `${this.property}:'${this.value}'`;
    }
    return `${this.property}:*`;
  }

  toComponentString(filterSchema, translateService) {
    const node = filterSchema
      ? filterSchema.getFilterByName(this.property)
      : undefined;
    let label = '';
    if (translateService) {
      if (node) {
        label = `${
          translateService.messages[node.getLabel()]
            ? translateService.formatMessage({id: node.getLabel()})
            : node.getLabel()
        }: `;
      }
    } else if (node) {
      label = `${node.getLabel()}: `;
    }
    return `${label}${this.value}`;
  }
}

export default TextFilter;
